module.exports = __webpack_public_path__ + "img/Add.60913c1a.svg";